const ManageCms = {
  getCms: {
    url: "/cms",
    method: "GET",
  },
  getSingleCms: (cmsPageId) => ({
    url: `cms/${cmsPageId}`,
    method: "GET",
  }),
  updateCms: (cmsPageId) => ({
    url: `cms/${cmsPageId}`,
    method: "PUT",
  }),
  addFaq: {
    url: "/faq",
    method: "POST",
  },
  getFaq: {
    url: "/faq",
    method: "GET",
  },
  deleteFaq: (id) => ({
    url: `/faq/${id}`,
    method: "DELETE",
  }),
  getSingleFAQs: (id) => ({
    url: `/faq/${id}`,
    method: "GET",
  }),
  updateFAQ: (id) => ({
    url: `/faq/${id}`,
    method: "PUT",
  }),
};
export default ManageCms;
